var React = require('react');

function TwitterInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"m22 22-7.367-11.333L22 2h-3l-5.667 6.667L9 2H2l7.367 11.333L2 22h3l5.667-6.667L15 22h7Zm-3.685-2L7.915 4h-2.23l10.4 16h2.23Z","clipRule":"evenodd"}));
}

TwitterInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","role":"img","aria-label":"Twitter"};

module.exports = TwitterInline;

TwitterInline.default = TwitterInline;
